import {SOPostAssignedProject} from '../../core/assigned-project/so-post-assigned-project';
import {AssignedProjectCore} from './assigned-project.core';
import {SOGetAssignedProject} from '../../core/assigned-project/so-get-assigned-project';
import {FormField, SelectionOption} from 'lionheartland';
import {postAssignedProjectFormFieldOptions} from './post-assigned-project-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {PersonCore} from '../person/person.core';
import {SOGetPerson} from '../../core/person/so-get-person';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostAssignedProject extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postAssignedProjectFormFieldOptions);

  RequestClass = SOPostAssignedProject

  constructor(
    public entityCore: AssignedProjectCore
  ) {
    super();
    if (postAssignedProjectFormFieldOptions.person) {
      postAssignedProjectFormFieldOptions.person.makeCore = true;
    }
    if (postAssignedProjectFormFieldOptions.project) {
      postAssignedProjectFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'person',
        SOGetPerson,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}